import React from 'react';

import { useRecoilValue } from 'recoil';

import { hasModule } from 'lib/helpers/utility';

import NotFound from 'components/NotFound';
import { modulesState } from 'components/state';
import Loader from 'components/shared/Loader/Loader';

const RequireModule = ({ module, logicType = 'and', children }) => {
  const practiceModules = useRecoilValue(modulesState);

  if (!practiceModules?.loaded) {
    return (
      <div className="flex h-full flex-1 items-center justify-center">
        <Loader color="primary" size={40} />
      </div>
    );
  }

  return hasModule(practiceModules, module, logicType) ? children : <NotFound />;
};

export default RequireModule;
